import {get} from "../../api"
import * as url from "../../url"

const apiGetEnumVersionsList = data => {
  return get(url.API_ENUM_VERSIONS, data.history)
}

export {
  apiGetEnumVersionsList,
}
